import { Model } from '@/models/Model';
import client from '@/support/Client';
import { DateTime } from 'luxon';
export class DateTimeslot extends Model {
    constructor() {
        super(...arguments);
        this.$name = 'DateTimeslot';
        this.$endpoint = '/datetimeslots';
        this.$fillable = ['starts_at', 'ends_at'];
    }
    get calendarEvent() {
        const parsedEvent = {
            id: this.id || '',
            title: this.title || '',
            start: this.starts_at ? DateTime.fromSQL(this.starts_at).toISO() : '',
            end: this.ends_at ? DateTime.fromSQL(this.ends_at).toISO() : '',
            extendedProps: {
                type: 'date-time-slot',
                events: this.events,
                is_valid: this.is_valid,
                audits: this.audits,
            },
            className: `slot__event`,
        };
        return parsedEvent;
    }
    audit() {
        const url = this.$endpoint + '/' + this.resolvePrimaryKey() + '/audits';
        return client('get', url, {}).then((response) => {
            return Promise.resolve(response.data);
        }, (error) => {
            return Promise.reject(error);
        });
    }
    freeStudents(payload) {
        return client('post', `${this.$endpoint}/free-students`, payload);
    }
}
